import React from 'react'
import { Button, Modal } from 'react-bootstrap'
import { ErrorMessage, Field, Form, Formik } from 'formik'
import * as yup from 'yup'

const EditAboutModal = ({ isOpen, onClose, data, onSubmit }) => {
  const validationSchema = yup.object().shape({
    content_en: yup.string().required('English content is required'),
    content_ka: yup.string().required('Georgian content is required'),
  })

  const initialValues = {
    content_en: data?.content_en || '',
    content_ka: data?.content_ka || '',
  }

  return (
    <Modal
      show={isOpen}
      onHide={onClose}
      size='lg'
      aria-labelledby='contained-modal-title-vcenter'
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title id='contained-modal-title-vcenter'>რედაქტირება</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Formik
          initialValues={initialValues}
          onSubmit={(values, { setSubmitting }) => {
            onSubmit(values, { setSubmitting })
          }}
          validationSchema={validationSchema}
        >
          {({ setFieldValue, isSubmitting }) => (
            <Form>
              <div className='flex flex-col gap-4 p-3.5'>
                {[
                  ['content_en', 'ტექსტი (EN)'],
                  ['content_ka', 'ტექსტი (KA)'],
                ].map(([field, label]) => (
                  <span key={field}>
                    <label htmlFor={field} className='text-lg'>
                      {label}
                    </label>
                    <Field
                      as='textarea'
                      className='border rounded py-2 px-2 w-full min-h-36 whitespace-pre-line'
                      autoComplete='off'
                      type='text'
                      name={field}
                      placeholder={label}
                    />
                    <ErrorMessage
                      style={{ color: 'red', fontSize: '14px' }}
                      name={field}
                      component='span'
                    />
                  </span>
                ))}

                <div className='flex flex-row items-center gap-3 justify-end w-full'>
                  <Button variant='primary' type='submit' disabled={isSubmitting}>
                    შენახვა
                  </Button>
                  <Button variant='secondary' onClick={onClose}>
                    Cancel
                  </Button>
                </div>
              </div>
            </Form>
          )}
        </Formik>
      </Modal.Body>
    </Modal>
  )
}

export default EditAboutModal
